module.exports = __webpack_public_path__ + "static/img/img_10.fe78ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code/img_10.jpg
// module id = 65
// module chunks = 20